import { render, staticRenderFns } from "./IntroductionSection.vue?vue&type=template&id=35376578&scoped=true&"
import script from "./IntroductionSection.vue?vue&type=script&lang=js&"
export * from "./IntroductionSection.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionSection.vue?vue&type=style&index=0&id=35376578&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35376578",
  null
  
)

export default component.exports